import apiClient from './apiClient'

export type NewsflashSeverity = 'info' | 'warning' | 'critical'
export type NewsflashAction = 'seen' | 'dismiss' | 'confirm'

export interface Newsflash {
  newsflashId: number
  title: string
  summary: string
  /** Headings, paragraphs, bold and lists only — cleaned by the console on save. */
  bodyHtml: string
  severity: NewsflashSeverity
  /** UK time, `YYYY-MM-DDTHH:MM:SS`, or null when open-ended. */
  endsAt: string | null
  closable: boolean
  needsConfirm: boolean
}

// The backend returns snake_case; map to camelCase.
interface NewsflashResponse {
  newsflash_id: number
  title: string
  summary: string
  body_html: string
  severity: NewsflashSeverity
  ends_at: string | null
  closable: boolean
  needs_confirm: boolean
}

export const getNewsflashes = async (): Promise<Newsflash[]> => {
  const response = await apiClient.get<NewsflashResponse[]>('/newsflashes')
  return response.data.map(n => ({
    newsflashId: n.newsflash_id,
    title: n.title,
    summary: n.summary,
    bodyHtml: n.body_html,
    severity: n.severity,
    endsAt: n.ends_at,
    closable: n.closable,
    needsConfirm: n.needs_confirm,
  }))
}

export const postNewsflashAction = async (
  newsflashId: number,
  action: NewsflashAction
): Promise<void> => {
  await apiClient.post(`/newsflashes/${newsflashId}/${action}`)
}
